

















import { Vue, Component, Prop } from 'vue-property-decorator'
import * as db from '@shared/types/database'

@Component({})
export default class TestInfo extends Vue {
  @Prop({ required: true }) readonly status!: db.TestStatus
  @Prop({ default: true }) isTemplated!:boolean
}
